import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Plans } from '../constants';

const OptionButtons = ({ handleChange, selected }) => (
  <div className="trial-upgrade__buttons">
    <div
      className={cx('trial-upgrade__buttons__box', { active: selected === Plans.SEASONAL })}
      role="button"
      tabIndex="0"
      onClick={() => handleChange(Plans.SEASONAL)}
      onKeyDown={() => handleChange(Plans.SEASONAL)}
    >
      {selected === Plans.SEASONAL && <div className="active-check"><i className="fas fa-check-circle" /></div>}
      <div className="trial-upgrade__buttons__title">
        SEASONAL
      </div>
      <div className="trial-upgrade__buttons__price">
        $49.99 USD
      </div>
      <div className="trial-upgrade__buttons__type">
        Standard
      </div>
    </div>
    <div
      className={cx('trial-upgrade__buttons__box', { active: selected === Plans.ANNUAL })}
      role="button"
      tabIndex="0"
      onClick={() => handleChange(Plans.ANNUAL)}
      onKeyDown={() => handleChange(Plans.ANNUAL)}
    >
      {selected === Plans.ANNUAL && <div className="active-check"><i className="fas fa-check-circle" /></div>}
      <div className="trial-upgrade__buttons__title">
        ANNUAL
      </div>
      <div className="trial-upgrade__buttons__price through">
        $199.99 USD
      </div>
      <div className="trial-upgrade__buttons__price spaced">
        $179.99 USD!
      </div>
    </div>
  </div>
);

OptionButtons.defaultProps = {
  handleChange: () => null,
  selected: Plans.SEASONAL,
};

OptionButtons.propTypes = {
  handleChange: PropTypes.func,
  selected: PropTypes.string,
};

export default OptionButtons;
